import { useTheme } from "@mui/material";

type ScoreProgressBarProps = {
    label: string;
    value: number;
};

/**
 * Semantic score bar matching the Product V2 Figma geometry.
 *
 * This stays independent from Material's visual progress component: the FOODS
 * progress primitive is designed for questionnaire completion and has a
 * rounded track/value badge that does not match score breakdowns.
 */
export const ScoreProgressBar = ({ label, value }: ScoreProgressBarProps) => {
    const theme = useTheme();
    const normalizedValue = Math.min(100, Math.max(0, value));

    return (
        <div
            aria-label={label}
            aria-valuemax={100}
            aria-valuemin={0}
            aria-valuenow={normalizedValue}
            role="progressbar"
            style={{
                backgroundColor: "inherit",
                height: theme.spacing(2),
                overflow: "visible",
                width: "100%",
            }}
        >
            <div
                aria-hidden
                style={{
                    backgroundColor: theme.palette.primary[600],
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: theme.spacing(0.5),
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: theme.spacing(0.5),
                    height: "100%",
                    minWidth: theme.custom.barChart.zeroValueWidth,
                    width: `${normalizedValue}%`,
                }}
            />
        </div>
    );
};
